import { all } from 'redux-saga/effects';
import { authSagas } from './authSagas';
import { resourceSagas } from './resourceSagas';
import { slotSagas } from './slotSagas';
import { experienceSagas } from './experienceSagas';

export default function* rootSaga() {
  yield all([...authSagas, ...resourceSagas, ...slotSagas, ...experienceSagas]);
}
